<template>

  <div class="m-2">
    <loading-spinner v-if="loading" />
    <template v-else>
      <div>
        <b-row>
          <b-col :cols="2"></b-col>
          <b-col :cols="8" class="text-center">
            <h4 style="color: #49a8e8">
              <strong>{{dashboard.title}}</strong>
            </h4>
            <h6>
              <p>{{dashboard.description}}</p>
              <p v-if="!!this.start_date && !!this.end_date"><strong>Report period:</strong> {{prettifySelectedPeriod(this.start_date, this.end_date)}}</p>
            </h6>
          </b-col>
          <b-col :cols="2"></b-col>
        </b-row>
        <b-row>
          <b-col :cols="8" class="text-left" style="margin-bottom: 10px">
            <h5 v-if="view === 'insights'">Select Date Range</h5>
            <vue-ctk-date-time-picker  v-if="view === 'insights'"
              id="RangeDatePicker"  label="Select a date range" v-model="range_value"
              format="YYYY-MM-DD" :range="true" formatted="ll">
                <b-button variant="primary"
                  class="m-2" size="md">Current Month</b-button>
              </vue-ctk-date-time-picker>
          </b-col>
          <b-col :cols="4" class="text-right" style="margin-top: 30px">
            <b-form-group>
              <b-form-radio-group v-if="this.dashboard.title === 'Agents'"
                v-model="view"
                :options="[
                    {value: 'insights', text: 'INSIGHTS'},
                    {value: 'list', text: 'LIST VIEW'}
                  ]"
                buttons/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col :cols="8">
            <h5  v-if="view === 'insights' && this.dashboard.title === 'Agents'">Select Agent</h5>
            <b-form-select
            v-if="view === 'insights' && this.dashboard.title === 'Agents'"
            :options="options"
            v-model="selected"
            style="max-width: 300px; margin-bottom:20px;"
            size="lg"/>
          </b-col>
<!--          <b-col  :cols="8"  class="text-left" style="margin-bottom: 10px" >-->
<!--            <h5  v-if="view === 'insights'">Select Date Range</h5>-->
<!--            <vue-ctk-date-time-picker  v-if="view === 'insights'"-->
<!--              id="RangeDatePicker"  label="Select a date range" v-model="range_value"-->
<!--              format="YYYY-MM-DD" range = true formatted="ll">-->
<!--                <b-button variant="primary"-->
<!--                  class="m-2" size="md">Current Month</b-button>-->
<!--              </vue-ctk-date-time-picker>-->
<!--          </b-col>-->
        </b-row>
      </div>

      <div class="animated fadeIn" v-if="view === 'insights'">
        <b-row>
          <b-col v-for="summary in this.summary_insights" :key="summary.id" :cols="3">
            <!-- <div class="column"> -->
            <b-card-group deck >
              <b-card class="text-center" header-tag="header" footer-tag="footer" style="width: 250px;">
                <template v-slot:header>
                  <h6 class="mb-0" :id="summary.id">{{summary.title}}</h6>
                  <b-tooltip :target="summary.id" placement="bottom">
                    {{summary.description}}
                  </b-tooltip>
                </template>
                <!-- <b-card-text>Header and footers using slots.</b-card-text> -->
                <template>
                  <div class="h4 m-0 p-0 text-center" style="font-size: 35px; color: #20A8D8">
                    {{abbreviateNumber(summary.chart_data.data)}}
                  </div>
                </template>
                <!-- <template v-slot:footer>
                  <em></em>
                </template> -->
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols :md="12" v-if="this.growth_data != null" style="margin-top: 1rem">
            <b-card-group deck>
              <b-card>
                <growth-chart
                  primary
                  :data="this.growth_data"
                  :percentage="false"
                  :title="`${this.growth_chart_config.title}`"
                  :value-name="`New`"
                  :value-title="growthTitles.value"
                  :aggregation-name="`Cumulative`"
                  :aggregation-title="growthTitles.aggregation" />
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>

        <b-row>
          <!-- <b-col  cols :md="6" :sm="12"> -->
          <b-col cols :md="columnWidth(insight.config.xlabeltype)" :sm="12" v-for="insight in this.chart_insights"
            :key="insight.id">
            <categorical-insight
              :name="insight.title"
              :subtitle="insight.config.subtitle"
              :values="insight.value"
              :xlabel="insight.config.xlabel"
              :xlabeltype="insight.config.xlabeltype"
              :ylabel="insight.config.ylabel"
              :default-chart="insight.config.default_chart_type"
              :drilldown="insight.config.drill_down"
              :width="4"
              :isString=true>

            </categorical-insight>
            <!-- <categorical-insight :name="pie_chart_name" :values="values" :isString=true></categorical-insight> -->
          </b-col>
          <br/>
        </b-row>
      </div>
      <div v-else>
        <agents-list
          class="mb-2; mt-2" action-text="view"
          :enableAction=true
          :enableSort=true
          :enableFilter=true
          :values="list_view_insights"
          :filter="filter"
          :active="view === 'list'"
          :rowCount="list_view_insights.length"
          :defaultColumns="defaultCols"
          @act="sendAgentsMail">

        </agents-list>

      </div>
      <div class="text-center m-5"></div>
    </template>
  </div>
</template>

<script>
import axios from "axios";
import { fullURL, fetchInsight } from "../../utils";
import LoadingSpinner from "../LoadingSpinner";
import CategoricalKeyInsight from "../Insights/CategoricalKeyInsight";
import CategoricalInsight from "../Insights/CategoricalInsight";
import AgentsList from './AgentsList'
import GrowthChart from '../Insights/GrowthChart'
import ListKeyInsight from '../List/ListKeyInsight';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import moment from "moment";
import {round} from "lodash/math";
const parseCategory = (value, type) => {
  if (type === "date") {
    return moment(value).format("MMM DD, YYYY");
  }
  return value;
};

export default {
  name: "AgentsReports",
  components: {
    LoadingSpinner,
    CategoricalKeyInsight,
    ListKeyInsight,
    CategoricalInsight,
    AgentsList,
    GrowthChart,
    VueCtkDateTimePicker
  },
  props: {
    dashboard: Object
  },
  data() {
    const {view} = this.$route.query;
    const dashboards = this.$store.state.files.dashboards;
    return {
      range_value:null,
      view: view === "list" ? view : 'insights',
      count: null,
      chart_data: null,
      chart_description: null,
      loading: true,
      summary_insights:[],
      chart_insights: [],
      growth_chart_config: null,
      report_ids:[],
      dashboards:dashboards,
      growth_data: null,
      start_date: null,
      end_date: null,
      // options: [
      //     { value: null, text: 'All Agents' }],
      selected: -1,
      defaultCols: [],
      list_view_insights: [],
      filter: {
          method: "dynamic",
          values: {
            logic: "and",
            filters: []
          }
        },
      conversion_rate: null
    };
  },

  created() {
    console.log("Dashboard reports: ", this.dashboard.report_ids);
    if (!!this.dashboard.report_ids && this.dashboard.report_ids.length > 0) {
      const request_data = "?dashboard_id="+this.dashboard.id
      this.dashboard.report_ids.forEach(id=>
        axios.get(
        fullURL(
            `/dashboards/report/${id}` + request_data
          )
      ).then(({data}) =>{
          if(data.report_type === 'summary'){
            this.summary_insights.push(data);
          }
          else if(data.report_type === 'growth_chart') {
            console.log('DB Config: ', data);
            this.growth_chart_config = data;
            let col = data['collection'];
            let filters = this.filter;
            console.log("Growth Data: ", this.growth_chart_config.chart_data.data);
            this.growth_data = data.chart_data.data;
          }
          else if(data.report_type === 'chart'){
            console.log("CHART_DATA", data);
            if (data.chart_config.drill_down && data.chart_config.subtitle) {
              this.chart_insights.push({"title": data.title, "config": data.chart_config,"value": data.chart_data.data});
            }
            data.chart_data.data.sort(this.sortByMonthYearDate)
            this.chart_insights.push({"title": data.title, "config": data.chart_config,"value": data.chart_data.data.map(e=>([this.formatDateText(e['_id']),round(e['count'])]))});
            console.log("chart insights", this.chart_insights);
          }
      }).catch(console.log)
        .finally(() => {
          this.loading = false;
        })
      );
    }

    // axios.get(
    //   fullURL(`/custom-reports/agents`)
    // ).then(({data}) => {
    //     this.list_view_insights = data.data;
    //     this.defaultCols = data.defaultColumns;
    //   }
    // )
  },

  watch:{
    range_value(val) {
      const {start, end} = val;

      console.log("range_value is", this.range_value)

      if (start != null && end != null) {
        console.log("start_date", start);
        console.log("end_date", end);
        console.log("selected agent now is ", this.selected );
        this.start_date = start;
        this.end_date = end;
        this.reloadData()

        // console.log("selected agent is ", document.getElementById("agent_selection").value)

      } else {
        console.log("something is not complete")
      }
      // this.summary_insights = [];
      // this.chart_insights = [];
    },

    selected(val){
      this.reloadData()
    }

  },

  computed:{
    options(){
      let result = [{text: "All Agents", value: -1}]
      let a = this.list_view_insights.map(({_id, name, phoneNumber}) => ({text:name, value:phoneNumber}));
      result = result.concat(a)
      return result
    },

    growthTypeOptions() {
      return [
        {value: 'count', text: 'Total Count'},
        {value: 'amount', text: 'Total Amount'},
        {value: 'average', text: 'Average Amount'},
        {value: 'percent_count', text: 'Count %'},
        {value: 'percent_amount', text: 'Amount %'},
      ];
    },

    growthType() {
      // if (this.growthTypeIsPercentage) {
      //   return this.growthTypeKey.substr('percent_'.length);
      // }
      // return this.growthTypeKey;
      return 'count';
    },

    growthTitles() {
      const suffix = ''; // this.growthTypeIsPercentage ? ' (%)' : '';
      const name = ((growthType) => {
        switch (growthType) {
          case 'average':
            return 'Average Amount';
          case 'amount':
            return 'Amount';
          default:
            return 'Count';
        }
      })(this.growthType);

      return {
        value: `New ${this.growth_chart_config.collection} ${name} ${suffix}`,
        aggregation: `Total ${this.growth_chart_config.collection} ${name} ${suffix}`
      };
    }
  },

  methods: {
    collection_name() {
      return 'agents';
    },

    columnWidth(xlabelType) {
      return (!!xlabelType && xlabelType !== 'string') ? 6 : 6;
    },

    sendAgentsMail(record){
      const record_id = record["phoneNumber"];
      const confirmed_email =  record["confirmed_email"]
      const today = new Date();
      const start = new Date(today.getFullYear(), 0, 1, 1).toISOString().slice(0, 10);
      const end_date = new Date(today.getFullYear(), today.getMonth() + 1, 1, 1);
      end_date.setDate(end_date.getDate() - 1);
      const end = end_date.toISOString().slice(0, 10);
      const current_month = today.getMonth() + 1;
      const current_year = today.getFullYear()
      axios({
      method: 'post',
      url: fullURL('/custom-reports/agent-report/summary/email'),
      data: {
          "email": confirmed_email,
          "year": today.getFullYear(),
          "month": today.getMonth() + 1,
          "customer_id": record_id},

      }
      ).then(
          ({data}) =>{
              console.log("Email Sent")

          }
      );
        // this.$router.push(`/custom-reports/agent-report/summary/${record_id}`);
    },

    reloadData() {
      console.log("reload data loading")
      let date_range = this.range_value;
      let selected_agent = this.selected;

      let start_date = null;
      let end_date = null;

      if (date_range != null) {
        start_date = date_range.start
        end_date = date_range.end
      }

      let request_data = "?dashboard_id="+this.dashboard.id + "&"
      if (start_date != null && end_date != null) {
        request_data += "start_date="+start_date+"&end_date="+end_date
      }
      if (selected_agent != null && selected_agent > -1) {
        request_data+= "&agent_id="+selected_agent
      }

      this.summary_insights = [];
      this.chart_insights = [];
      console.log("summary_insights", this.summary_insights)
      this.dashboard.report_ids.forEach(id=>
        axios.get(
        fullURL(`/dashboards/report/${id}` + request_data)
      ).then(({data}) =>{
          if(data.report_type === 'summary'){
            this.summary_insights.push(data);
          }
          else if (data.report_type === 'growth_chart') {
            console.log('DB Config: ', data);
            this.growth_chart_config = data;
            console.log("Growth Data: ", this.growth_chart_config.chart_data.data);
            this.growth_data = data.chart_data.data;
          }
          else if(data.report_type === 'chart'){
            console.log("CHART_DATA", data);
            if (data.chart_config.drill_down && data.chart_config.subtitle) {
                this.chart_insights.push({"title": data.title, "config": data.chart_config,"value": data.chart_data.data});
              }
            data.chart_data.data.sort(this.sortByMonthYearDate)

            this.chart_insights.push({"title": data.title, "config": data.chart_config,"value": data.chart_data.data.map(e=>([this.formatDateText(e['_id']),round(e['count'])]))});
          }
      }).catch(console.log)
        .finally(() => {
          this.loading = false;
        })
      );
    },

    abbreviateNumber(number) {
      var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
      var tier = Math.log10(number) / 3 | 0;
      if(tier == 0) {
        if (number % 1 !== 0) {
          return round(number)
        }
        return number;
      }
      var suffix = SI_SYMBOL[tier];
      var scale = Math.pow(10, tier * 3);
      var scaled = number / scale;
      return scaled.toFixed(1) + suffix;
    },

    formatDateText(month_year) {
      let month_names = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      let month_names_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      if (month_year && month_year.includes("-")) {
        let res = month_year.split("-");
        return month_names[res[1] - 1] + " " + res[2] + " " + res[0];
      }
      else if (month_year && month_year.includes("/")) {
        let res = month_year.split("/");
        return month_names_short[res[0] - 1] + " " + res[1];
      }
      return month_year
    },

    sortByMonthYearDate(a,b) {
      a = a["_id"]
      b = b["_id"]
    var as = a.split('/'),
        bs = b.split('/'),
        ad = new Date(as[0]+' 1,'+as[1]),
        bd = new Date(bs[0]+' 1,'+bs[1]);
    return ad.getTime() - bd.getTime();
  },

    prettifySelectedPeriod(start_date, end_date) {
      const today = moment();
      const start = moment(start_date, "YYYY-MM-DD");
      const end = moment(end_date, "YYYY-MM-DD");
      const next_end = moment(end_date, "YYYY-MM-DD").add(1, "days");
      let diff = start.diff(end, "days");
      console.log("Pretty: ", (start.date() == 1), (start.month() == 0), (end.month() == 11), (next_end.date() == 1));
      if ((start.date() == 1) && (start.month() == 0) && (end.month() == 11) && (next_end.date() == 1)) {
        return start.format("YYYY");
      }
      else if ((start.date() == 1) && (next_end.date() == 1) && (end.month() == start.month())) {
        console.log("Pretty: ", start.format("MMMM, YYYY"));
        return start.format("MMMM, YYYY");
      }
      else if (end.diff(start, "days") == 6) {
        if ((start < today) && (today < end)) {
          return "This Week";
        }
        else if ((end < today) && (today.diff(end, "days") < 7)) {
          return "Last Week";
        }
      }
      else if ((end.diff(start, "days") < 31) && (end.month() == today.month()) && (end.date() == today.date())) {
        return "The Last " + end.diff(start, "days") + " Days";
      }
      else {
        return start_date + " - " + end_date;
      }
    },

    getGrowthData() {
      let data = null;

      return data;
    },

    testData() {
      return [["v50.0",0.96],["v49.0",0.82],["v12.1",0.14]]
    }
  }
};
</script>

<style scoped>
</style>
